import React, { lazy, Suspense } from 'react';
import { createBrowserRouter } from 'react-router-dom';

import { PageRoute } from './constants/page-route.const';
import { Home } from './pages/landing-home/home';
import { NotFound } from './pages/not-found/not-found';
import { MarketingRootLayout } from './seo/marketing-root-layout';

const About = lazy(() => import('./pages/company-about/about').then((m) => ({ default: m.About })));
const BecomePartner = lazy(() =>
  import('./pages/become-partner/become-partner').then((m) => ({ default: m.BecomePartner })),
);
const BookDemoRedirect = lazy(() =>
  import('./pages/book-demo-redirect').then((m) => ({ default: m.BookDemoRedirect })),
);
const PerksPage = lazy(() =>
  import('./pages/perks/perks-page').then((m) => ({ default: m.PerksPage })),
);
const Solutions = lazy(() =>
  import('./pages/solutions/solutions').then((m) => ({ default: m.Solutions })),
);
const Terms = lazy(() => import('./pages/terms/terms').then((m) => ({ default: m.Terms })));

const withSuspense = (node: React.ReactNode) => (
  <Suspense fallback={<div aria-hidden className="min-h-screen" />}>{node}</Suspense>
);

const router = createBrowserRouter([
  {
    element: <MarketingRootLayout />,
    children: [
      {
        path: '/',
        element: <Home />,
      },
      {
        path: '/solutions/:tab',
        element: withSuspense(<Solutions />),
      },
      {
        path: '/solutions',
        element: withSuspense(<Solutions />),
      },
      {
        path: '/perks',
        element: withSuspense(<PerksPage />),
      },
      {
        path: '/become-a-partner',
        element: withSuspense(<BecomePartner />),
      },
      {
        path: '/contact-sales',
        element: withSuspense(<BookDemoRedirect />),
      },
      {
        path: `${PageRoute.TERMS_BASE}/:tab?`,
        element: withSuspense(<Terms />),
      },
      {
        path: '/about',
        element: withSuspense(<About />),
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
]);

export default router;
